/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useMemo, useState } from 'react';
import { ADGMModal, ADGMPanel, ADGMSelect, ADGMTextField, ADGMImage } from 'aurora-components';
import PropTypes from 'prop-types';
import { Hidden, Typography, Divider, Box } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import AddIcon from '@material-ui/icons/Add';

import { keyEmptyCheck, formatCurrencyWithoutCurrency } from 'aurora-utils/utils';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import Link from '@material-ui/core/Link';
import isEmpty from 'lodash/isEmpty';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import styles from './style';
const ADGMItemsList = ({
  onRemove,
  onAdd,
  onEdit,
  onFieldChange,
  modalFields,
  isModalOpened,
  isItemEditable,
  onCloseModal,
  setModalOpened,
  onEditItem,
  classes,
  buttonText,
  items,
  fields,
  modalTitle,
  isEditable,
  isModalBtnDisabled,
  ...props
}) => {
  const [entityCollapse, setEntityCollapse] = useState(true);

  const onSubmit = useCallback(() => {
    isItemEditable ? onEdit(modalFields) : onAdd(modalFields);
    onCloseModal();
  }, [isItemEditable, items, modalFields]);

  const claimValues = useMemo(() => {
    return items?.reduce((acc, currentValue) => {
      return acc + +currentValue.claimValue + +currentValue.claimValue * (+currentValue.interest / 100);
    }, 0);
  }, [items]);

  const data = useMemo(() => {
    return entityCollapse && items && !isEditable ? [...items]?.splice(0, 2) : items;
  }, [items, entityCollapse, isEditable]);

  if (!isEditable && !items?.length) {
    return null;
  }

  return (
    <ADGMPanel hasPadding {...props} classes={{ containerPadding: classes.containerPadding }}>
      <div className={data?.length > 0 ? isEditable : null}>
        {data?.map((item, index) => {
          return (
            <div
              className={classNames(classes.item, !isEditable && classes.itemReadOnly)}
              key={`${item?.Demand}-${index + 1}`}
            >
              <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                <span className={classNames(classes.index, !isEditable && classes.modifiedIndex)}>
                  <span>{index + 1}</span>
                </span>
                <Box component='p'>{item?.demand}</Box>
              </Box>
              <Box component='p'>
                {keyEmptyCheck('claim_value_')}:
                {keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(item?.claimValue) })}
              </Box>
              <Box component='p' display='inline-block'>
                {keyEmptyCheck('interest_percentage')}: {item?.interest}%
              </Box>
              {isEditable && (
                <>
                  <Hidden xsDown>
                    <div>
                      <span className={classes.btn} onClick={() => onRemove(item)}>
                        {keyEmptyCheck('remove')}
                      </span>
                      <span className={classes.btn} onClick={() => onEditItem(item)}>
                        {keyEmptyCheck('Edit')}
                      </span>
                    </div>
                  </Hidden>

                  <Hidden smUp>
                    <Divider className={classes.divider} />
                    <Box className={classes.mobileActions} gridGap='1em'>
                      <Button
                        onClick={() => onEditItem(item)}
                        variant='text'
                        startIcon={<ADGMImage name='PencilBlack.svg' alt='edit-pencil' width='14px' height='14px' />}
                      >
                        {keyEmptyCheck('Edit')}
                      </Button>
                      <Button
                        variant='text'
                        onClick={() => onRemove(item)}
                        startIcon={<ADGMImage name='Trash.svg' alt='delete-dustbin' width='14px' height='14px' />}
                      >
                        {keyEmptyCheck('delete')}
                      </Button>
                    </Box>
                  </Hidden>
                </>
              )}
            </div>
          );
        })}
      </div>

      {!isEditable && !isEmpty(items) && items.length > 2 ? (
        <Box className={classes.viewMoreWrapper} textAlign='center' py='1em'>
          <Link onClick={() => setEntityCollapse(!entityCollapse)} color='#130F26'>
            {entityCollapse ? keyEmptyCheck('see_all_demands') : keyEmptyCheck('see_less_demands')}
            {!entityCollapse ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Link>
        </Box>
      ) : (
        ''
      )}
      {isEditable && !isEmpty(items) ? (
        <Hidden smDown>
          {' '}
          <Divider className={classes.divider} />
        </Hidden>
      ) : (
        !isEmpty(items) && <Divider className={classNames(classes.divider, classes.dividerMargin)} />
      )}
      <div className={classes.footer}>
        {isEditable && (
          <Button
            variant='outlined'
            className={classes.addActionBtn}
            startIcon={<AddIcon />}
            onClick={() => setModalOpened(true)}
          >
            {keyEmptyCheck(buttonText)}
          </Button>
        )}
        {claimValues > 0 && (
          <Box className={classNames(classes.claimText, !isEditable && classes.claimTextModified)}>
            <Typography component='p'>
              {keyEmptyCheck('total_claim_value', { number: '' })}
              {keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(Number(claimValues).toFixed(2)) })}
            </Typography>
          </Box>
        )}
      </div>
      {isModalOpened && (
        <ADGMModal open={isModalOpened} onClose={onCloseModal} className={classes.biggerWidth}>
          <div className={classes.modelHeader}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              {keyEmptyCheck(modalTitle)} <span className={classes.requiredStar}>*</span>
            </Typography>
            <ADGMImage name='cross_black.svg' alt='crossicon' aria-hidden='true' onClick={onCloseModal} />
          </div>
          {fields?.map(({ type, name, value, ...fieldProps }) => {
            return (
              <>
                {type === 'dropdown' ? (
                  <ADGMSelect {...fieldProps} />
                ) : (
                  <ADGMTextField
                    type={type}
                    name={name}
                    {...fieldProps}
                    value={modalFields[name]}
                    onChange={onFieldChange}
                  />
                )}
                <br />
              </>
            );
          })}
          {isEditable && (
            <div className={classes.addItemButton}>
              <Button variant='contained' color='primary' onClick={onSubmit} disabled={isModalBtnDisabled}>
                {keyEmptyCheck('submit')}
              </Button>
            </div>
          )}
        </ADGMModal>
      )}
    </ADGMPanel>
  );
};

ADGMItemsList.propTypes = {
  classes: PropTypes.object.isRequired,
  isEditable: PropTypes.object.isRequired,
  fieldsData: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  items: PropTypes.array.isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      placeholder: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['dropdown, text']).isRequired,
      required: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
  isModalBtnDisabled: PropTypes.bool,
  onFieldChange: PropTypes.func,
  modalFields: PropTypes.object,
  isModalOpened: PropTypes.bool,
  isItemEditable: PropTypes.bool,
  onCloseModal: PropTypes.func,
  setModalOpened: PropTypes.func,
  onEditItem: PropTypes.func,
};

ADGMItemsList.defaultProps = {
  onAdd: () => {},
  onEdit: () => {},
  onRemove: () => {},
  isModalBtnDisabled: false,
  onFieldChange: () => {},
  modalFields: {},
  isModalOpened: false,
  isItemEditable: false,
  onCloseModal: () => {},
  setModalOpened: () => {},
  onEditItem: () => {},
};
export default withStyles(styles)(ADGMItemsList);
